import type { Metier } from "models";
import { Endpoints } from "enums";
import { cometApiClient } from "./apiClients";

/**
 * Récupère tous les métiers
 * @returns Array<Metier>
 */
async function getAll(): Promise<Array<Metier>> {
  const url = Endpoints.METIERS;
  return cometApiClient.get(url);
}

export const metiersService = {
  getAll,
};
